export default {
    "en": {
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        }
    },
    "it": {
        "Please click the button below to verify your email address.": "Thank you for signing up for “Industrial product configurator!” We believe you’re going to love it. In order to better collaborate with you and insure clear communication, please confirm your email address. Just follow the link below. We will contact you shortly.",
        "Verify Email Address": "Verify Email Address",
        "If you did not create an account, no further action is required.": "If you did not create an account, no further action is required.",
        "footer_notification_link": "If you have problems by clicking the button: \"{actionText}\", copy and paste this URL in you browser: [{actionURL}]({actionURL})",
        "error_notification_email": "Error!",
        "hello_notification_email": "Dear Partner!",
        "Regards": "Regards",
        "Verify Your Email Address": "Verify Your Email Address!",
        "Before proceeding, please check your email for a verification link.": "Before proceeding, please check your email for a verification link.",
        "If you did not receive the email": "If you did not receive the email",
        "click here to request another": "click here to request another",
        "A fresh verification link has been sent to your email address.": "A fresh verification link has been sent to your email address.",
        "passwords": {
            "password": "Le password devono essere di almeno 6 caratteri e devono coincidere.",
            "reset": "La password è stata reimpostata!",
            "sent": "Promemoria della password inviato!",
            "token": "Questo token per la reimpostazione della password non è valido.",
            "user": "Non esiste un utente associato a questo indirizzo e-mail."
        },
        "dashboard": {
            "users_registered": "Registered users",
            "roles_created": "Created roles",
            "configurations_count": "Created configurations"
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds.",
            "Login": "Login",
            "LoginSub": "Login to your account",
            "Email Address": "Email address",
            "Password": "Password",
            "Remember Me": "Remember me",
            "Password Forgot": "Forgot Password?",
            "Require Access": "Request Access",
            "Require Access Sub": "If you don't have an account, request one!",
            "Reset Password": "Password Reset",
            "Reset Password Sub": "Reset your password",
            "Send Link": "Send reset link"
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "drawer": {
            "list": "Configuration list",
            "id": "Id",
            "name": "Name",
            "registered": "Created on",
            "owner": "Created by"
        },
        "users": {
            "users": "Users",
            "id": "ID",
            "user": "User",
            "roles": "Roles",
            "registered": "Registration date",
            "new": "New user",
            "save": "Save",
            "delete": "Delete",
            "email": "Email",
            "password": "Password",
            "name": "Full name",
            "created": "User have been created!",
            "updated": "user have been updated!",
            "deleted": "user have been deleted!",
            "edit": "Edit user",
            "delete_title": "Are you sure?",
            "delete_info": "Once deleted, the operation cannot be canceled!",
            "role": "Role",
            "slug": "Slug",
            "new_role": "New role",
            "role_used": "Used by",
            "permissions": "Permissions",
            "role_name": "Role name",
            "general": "General",
            "general_info": "Create new roles and choose the permissions to be assigned to the various users",
            "permissions_info": "Enable or disable permissions and choose module accesses",
            "roles_count": "{tot} of {use}",
            "commercial_ref": "Sales Person",
            "business_name": "Company name"
        },
        "menu": {
            "settings": "SETTINGS",
            "users": "Users",
            "roles": "Roles",
            "dashboard": "Dashboard",
            "drawer": "Configurator",
            "drawer_start": "Start Configurator",
            "drawer_list": "Configuration list"
        },
        "validation": {
            "accepted": "{attribute} deve essere accettato.",
            "active_url": "{attribute} non è un URL valido.",
            "after": "{attribute} deve essere una data successiva al {date}.",
            "after_or_equal": "{attribute} deve essere una data successiva o uguale al {date}.",
            "alpha": "{attribute} può contenere solo lettere.",
            "alpha_dash": "{attribute} può contenere solo lettere, numeri e trattini.",
            "alpha_num": "{attribute} può contenere solo lettere e numeri.",
            "array": "{attribute} deve essere un array.",
            "before": "{attribute} deve essere una data precedente al {date}.",
            "before_or_equal": "{attribute} deve essere una data precedente o uguale al {date}.",
            "between": {
                "numeric": "{attribute} deve trovarsi tra {min} - {max}.",
                "file": "{attribute} deve trovarsi tra {min} - {max} kilobyte.",
                "string": "{attribute} deve trovarsi tra {min} - {max} caratteri.",
                "array": "{attribute} deve avere tra {min} - {max} elementi."
            },
            "boolean": "Il campo {attribute} deve essere vero o falso.",
            "confirmed": "Il campo di conferma per {attribute} non coincide.",
            "date": "{attribute} non è una data valida.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "{attribute} non coincide con il formato {format}.",
            "different": "{attribute} e {other} devono essere differenti.",
            "digits": "{attribute} deve essere di {digits} cifre.",
            "digits_between": "{attribute} deve essere tra {min} e {max} cifre.",
            "dimensions": "Le dimensioni dell'immagine di {attribute} non sono valide.",
            "distinct": "{attribute} contiene un valore duplicato.",
            "email": "{attribute} non è valido.",
            "exists": "{attribute} selezionato non è valido.",
            "file": "{attribute} deve essere un file.",
            "filled": "Il campo {attribute} deve contenere un valore.",
            "gt": {
                "numeric": "{attribute} deve essere maggiore di {value}.",
                "file": "{attribute} deve essere maggiore di {value} kilobyte.",
                "string": "{attribute} deve contenere più di {value} caratteri.",
                "array": "{attribute} deve contenere più di {value} elementi."
            },
            "gte": {
                "numeric": "{attribute} deve essere uguale o maggiore di {value}.",
                "file": "{attribute} deve essere uguale o maggiore di {value} kilobyte.",
                "string": "{attribute} deve contenere un numero di caratteri uguale o maggiore di {value}.",
                "array": "{attribute} deve contenere un numero di elementi uguale o maggiore di {value}."
            },
            "image": "{attribute} deve essere un'immagine.",
            "in": "{attribute} selezionato non è valido.",
            "in_array": "Il valore del campo {attribute} non esiste in {other}.",
            "integer": "{attribute} deve essere un numero intero.",
            "ip": "{attribute} deve essere un indirizzo IP valido.",
            "ipv4": "{attribute} deve essere un indirizzo IPv4 valido.",
            "ipv6": "{attribute} deve essere un indirizzo IPv6 valido.",
            "json": "{attribute} deve essere una stringa JSON valida.",
            "lt": {
                "numeric": "{attribute} deve essere minore di {value}.",
                "file": "{attribute} deve essere minore di {value} kilobyte.",
                "string": "{attribute} deve contenere meno di {value} caratteri.",
                "array": "{attribute} deve contenere meno di {value} elementi."
            },
            "lte": {
                "numeric": "{attribute} deve essere minore o uguale a {value}.",
                "file": "{attribute} deve essere minore o uguale a {value} kilobyte.",
                "string": "{attribute} deve contenere un numero di caratteri minore o uguale a {value}.",
                "array": "{attribute} deve contenere un numero di elementi minore o uguale a {value}."
            },
            "max": {
                "numeric": "{attribute} non può essere superiore a {max}.",
                "file": "{attribute} non può essere superiore a {max} kilobyte.",
                "string": "{attribute} non può contenere più di {max} caratteri.",
                "array": "{attribute} non può avere più di {max} elementi."
            },
            "mimes": "{attribute} deve essere del tipo: {values}.",
            "mimetypes": "{attribute} deve essere del tipo: {values}.",
            "min": {
                "numeric": "{attribute} deve essere almeno {min}.",
                "file": "{attribute} deve essere almeno di {min} kilobyte.",
                "string": "{attribute} deve contenere almeno {min} caratteri.",
                "array": "{attribute} deve avere almeno {min} elementi."
            },
            "not_in": "Il valore selezionato per {attribute} non è valido.",
            "not_regex": "Il formato di {attribute} non è valido.",
            "numeric": "{attribute} deve essere un numero.",
            "present": "Il campo {attribute} deve essere presente.",
            "regex": "Il formato del campo {attribute} non è valido.",
            "required": "Il campo {attribute} è richiesto.",
            "required_if": "Il campo {attribute} è richiesto quando {other} è {value}.",
            "required_unless": "Il campo {attribute} è richiesto a meno che {other} sia in {values}.",
            "required_with": "Il campo {attribute} è richiesto quando {values} è presente.",
            "required_with_all": "Il campo {attribute} è richiesto quando {values} sono presenti.",
            "required_without": "Il campo {attribute} è richiesto quando {values} non è presente.",
            "required_without_all": "Il campo {attribute} è richiesto quando nessuno di {values} è presente.",
            "same": "{attribute} e {other} devono coincidere.",
            "size": {
                "numeric": "{attribute} deve essere {size}.",
                "file": "{attribute} deve essere {size} kilobyte.",
                "string": "{attribute} deve contenere {size} caratteri.",
                "array": "{attribute} deve contenere {size} elementi."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "{attribute} deve essere una stringa.",
            "timezone": "{attribute} deve essere una zona valida.",
            "unique": "{attribute} è stato già utilizzato.",
            "uploaded": "{attribute} non è stato caricato.",
            "url": "Il formato del campo {attribute} non è valido.",
            "uuid": "The {attribute} must be a valid UUID.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "name": "nome",
                "username": "nome utente",
                "first_name": "nome",
                "last_name": "cognome",
                "password_confirmation": "conferma password",
                "city": "città",
                "country": "paese",
                "address": "indirizzo",
                "phone": "telefono",
                "mobile": "cellulare",
                "age": "età",
                "sex": "sesso",
                "gender": "genere",
                "day": "giorno",
                "month": "mese",
                "year": "anno",
                "hour": "ora",
                "minute": "minuto",
                "second": "secondo",
                "title": "titolo",
                "content": "contenuto",
                "description": "descrizione",
                "excerpt": "estratto",
                "date": "data",
                "time": "ora",
                "available": "disponibile",
                "size": "dimensione"
            }
        }
    }
}
